export const keycloakConfig = {
  realm: process.env.REACT_APP_KEYCLOAK_REALM as string,
  url: process.env.REACT_APP_KEYCLOAK_URL,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID as string,
  sslRequired: "external",
  publicClient: true,
  confidentialPort: 0,
};
